import { render } from "./DataActions.vue?vue&type=template&id=6187ea73"
import script from "./DataActions.vue?vue&type=script&lang=js"
export * from "./DataActions.vue?vue&type=script&lang=js"

import "./DataActions.vue?vue&type=style&index=0&id=6187ea73&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/DataActions.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6187ea73"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6187ea73', __exports__)) {
    api.reload('6187ea73', __exports__)
  }
  
  module.hot.accept("./DataActions.vue?vue&type=template&id=6187ea73", () => {
    api.rerender('6187ea73', render)
  })

}


export default __exports__